import { alignCenterCellStyle, alignLeftCellStyle } from '@common/cellStyles';

export default [
  {
    headerName: 'BSM Account',
    field: 'bsmAccount',
    minWidth: 180,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'GL Account',
    field: 'glAccount',
    ...alignCenterCellStyle,
  },
];
